import { Grid } from "@mui/material";

import { AdvantageCards } from "./components/AdvantageCards";
import {
  CustomContainer,
  Observation,
  StyledBox,
  SubTitle,
  Title,
  TitleContainer,
} from "./styles/AdvantagesStyles";

export const Advantages = () => {
  return (
    <StyledBox aria-labelledby="vantagens">
      <CustomContainer maxWidth="lg">
        <Grid container spacing={{ xs: 6, sm: 8, md: 10 }}>
          <TitleContainer size={{ xs: 12 }}>
            <Title id="vantagens">
              O plano ideal para a sua empresa com a qualidade SulAmérica que
              você já conhece.
            </Title>

            <SubTitle>
              São muitos benefícios para garantir o bem-estar dos seus
              colaboradores e o sucesso do seu negócio.
            </SubTitle>
          </TitleContainer>

          <Grid size={{ xs: 12 }}>
            <AdvantageCards />
          </Grid>
        </Grid>
      </CustomContainer>

      <Observation>*Respeitando as regras de inclusão da apólice</Observation>
    </StyledBox>
  );
};

export default Advantages;